
export const disponibiliteOptions = [
    { value: 'immédiat', label: 'Immédiate' },
    { value: '1 mois', label: 'Dans 1 mois' },
    { value: '3 mois', label: 'Dans 3 mois' },
    { value: 'autre', label: 'Autre (sélectionner une date)' },
  ];

  export const languageLevelOptions = [
    { value: 'Débutant', label: 'Débutant' },
    { value: 'Intermédiaire', label: 'Intermédiaire' },
    { value: 'Avancé', label: 'Avancé' },
    { value: 'Langue maternelle', label: 'Langue maternelle' },
  ];

  export const languageOptions = [
    { value: 'Français', label: 'Français' },
    { value: 'Anglais', label: 'Anglais' },
    { value: 'Espagnol', label: 'Espagnol' },
    { value: 'Arabe', label: 'Arabe' },
  ];

    export const contractTypeOptions = [
      { value: 'CDI', label: 'CDI' },
      { value: 'Portage', label: 'Portage' },
      { value: 'Freelance', label: 'Freelance' },
    ];

    export const lieuxSouhaites = [
      "France", "Maroc"
    ]

    export const regionMaroc = [
      "Casablanca", "Rabat", "Tanger", "Marrakech"
    ]

    export const regionFrance = [
      "Île-de-France", "Auvergne-Rhône-Alpes", "Occitanie", "Provence-Alpes-Côte d’Azur"
    ]

// src/constants/secteurs.js
    export const secteurOptions = [
      { code: "01", libelle: "Agriculture / Pêche / Forêt / Environnement" },
      { code: "02", libelle: "Agroalimentaire" },
      { code: "03", libelle: "Industrie / Production" },
      { code: "04", libelle: "Énergie / Environnement" },
      { code: "05", libelle: "BTP / Construction / Génie civil" },
      { code: "06", libelle: "Architecture / Urbanisme" },
      { code: "07", libelle: "Transport / Logistique / Supply chain" },
      { code: "08", libelle: "Commerce / Distribution / Grande surface" },
      { code: "09", libelle: "Hôtellerie / Restauration / Tourisme" },
      { code: "10", libelle: "Services à la personne / Aide à domicile" },
      { code: "11", libelle: "Santé / Médical / Paramédical" },
      { code: "12", libelle: "Pharmaceutique / Biotechnologies" },
      { code: "13", libelle: "Banque / Assurance / Finance" },
      { code: "14", libelle: "Immobilier" },
      { code: "15", libelle: "Droit / Juridique / Notariat" },
      { code: "16", libelle: "Communication / Marketing / Publicité" },
      { code: "17", libelle: "Vente / Relation client / Télévente" },
      { code: "18", libelle: "Ressources humaines / Recrutement" },
      { code: "19", libelle: "Informatique / Développement / SI" },
      { code: "20", libelle: "Télécoms / Réseaux" },
      { code: "21", libelle: "Internet / Web / Digital" },
      { code: "22", libelle: "Conseil / Stratégie / Organisation" },
      { code: "23", libelle: "Audit / Comptabilité / Gestion" },
      { code: "24", libelle: "Éducation / Formation / Enseignement" },
      { code: "25", libelle: "Fonction publique / Collectivités" },
      { code: "26", libelle: "Culture / Spectacle / Loisirs" },
      { code: "27", libelle: "Sport / Bien-être" },
      { code: "28", libelle: "Sécurité / Défense" },
      { code: "29", libelle: "Recherche / Sciences / Innovation" },
      { code: "30", libelle: "Autres / Non classé" },
    ];



    export const companySizeOptions = [
      { value: 'Startup', label: 'Startup' },
      { value: 'TPE', label: 'TPE' },
      { value: 'TME', label: 'TME' },
      { value: 'Grand groupe', label: 'Grand groupe' },
    ];

    export const workEnvironmentOptions = [
      { value: 'Présentiel', label: 'Présentiel' },
      { value: 'Télétravail partiel', label: 'Télétravail partiel' },
      { value: 'Télétravail ponctuel', label: 'Télétravail ponctuel' },
      { value: 'Télétravail total', label: 'Télétravail total' },
    ];

    // edit talent status
    export const statusOptionsRecruteur = [
      { value: '', label: 'Status' },
      { value: 'A traiter', label: 'À traiter' },
      { value: 'Qualifie attente controle', label: 'Qualifié' }
    ];

    // Mes talents status

    export const statusColorMapRecruteur = [
      {
        value: 'A traiter',
        label: 'A traiter',
        style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'Qualifie attente controle',
        label: 'Qualifié',
        style: { backgroundColor: '#0076b6', color: 'white' }
      },
      {
        value: 'Recruté',
        label: 'Recruté',
        style: { backgroundColor: '#00a550', color: 'white' }
      },
      {
        value: 'Non défini',
        label: 'Non défini',
        style: { backgroundColor: '#00a550', color: 'white' }
      }
    ];
    
    //entreprise canditure detail status 
    export const entrepriseCandidatureStatus = [
        {
      value: 'A traiter', label: 'Candidature à traiter',
      style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'Refusé avant entretien',  label: 'Refusé avant entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Accepté pour entretien', label: 'Accepté pour entretien',
        style: { backgroundColor: '#0076b6', color: 'white' } 
      },
      {
        value: 'Non retenu après entretien', label: 'Non retenu après entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Recrutement confirmé', label: 'Recrutement confirmé',
        style: { backgroundColor: '#00a550', color: 'white' } 
      },
       {
    value: 'brouillon', label: 'Brouillon',
    style: { backgroundColor: '#f59e0b', color: 'white' } 
  },
    ];


        export const recruteurCandidatureStatus  = [
        {
      value: 'A traiter', label: 'Candidature envoyée',
      style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'Refusé avant entretien',  label: 'Refusé avant entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Accepté pour entretien', label: 'Accepté pour entretien',
        style: { backgroundColor: '#0076b6', color: 'white' } 
      },
      {
        value: 'Non retenu après entretien', label: 'Non retenu après entretien',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Recrutement confirmé', label: 'Recrutement confirmé',
        style: { backgroundColor: '#00a550', color: 'white' } 
      },
       {
    value: 'Brouillon', label: 'Brouillon',
    style: { backgroundColor: '#f59e0b', color: 'white' } 
  },
    ];
    
    //status de agent et commercial cvtheque
    export const statusOptions = [
      {
        value: '',
        label: 'Status',
        style: { backgroundColor: '#999999', color: 'white' } 
      },
      {
        value: 'A traiter',
        label: 'A traiter',
        style: { backgroundColor: '#000000', color: 'white' }
      },
      {
        value: 'En cours de traitement',
        label: 'En cours de traitement',
        style: { backgroundColor: '#ff8c00', color: 'white' }
      },
      {
        value: 'À recontacter',
        label: 'À recontacter',
        style: { backgroundColor: '#ff8c00', color: 'white' }
      },
      {
        value: 'Hors perimetre',
        label: 'Hors périmètre',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Refus reference',
        label: 'Refus d’être référencé(e)',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Injoignable',
        label: 'Injoignable',
        style: { backgroundColor: '#ff8c00', color: 'white' }
      },
      {
        value: 'Qualifie attente controle',
        label: 'Qualifié',
        style: { backgroundColor: '#0076b6', color: 'white' }
      },
      {
        value: 'Valide apres controle',
        label: 'Validé après contrôle',
        style: { backgroundColor: '#00a550', color: 'white' }
      },
      {
        value: 'Rejete apres controle',
        label: 'Rejeté après contrôle',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
      },
      {
        value: 'Recruté',
        label: 'Recruté',
        style: { backgroundColor: '#00a550', color: 'white' }
      },
      {
        value: 'brouillon',
        label: 'Brouillon',
        style: { backgroundColor: '#cd5c5c', color: 'white' }
        }
    ];
    
    export const MODEL_LABELS = {
      option1: "Modèle 1",
      option2: "Modèle 2",
      option3: "Modèle 3"
    };
    //Ajout mission
    export const RoleOptions = [
      { value: 'Direction générale', label: 'Direction générale' },
      { value: 'Ressources humaines / Recrutement', label: 'Ressources humaines / Recrutement' },
      { value: 'Manager opérationnel / Responsable d’équipe', label: 'Manager opérationnel / Responsable d’équipe' },
      { value: 'Direction technique / IT', label: 'Direction technique / IT' },
      { value: 'Direction commerciale / marketing', label: 'Direction commerciale / marketing' },
      { value: 'Support administratif / Office management', label: 'Support administratif / Office management' },
      { value: 'Autre', label: 'Autre' },
    ];
    
    